import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GridOptions } from 'ag-grid-community';
import * as moment from 'moment';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { debounceTime } from 'rxjs/operators';
import { UserModuleRoleComponent } from '../../../components';
import { BaseComponent } from '../../../core/components';
import { UserModel } from '../../../models';
import { DepartmentService, UserService } from '../../../services';
import StorageUtils from '../../utilities/storage.utils';
import { UsersEditComponent } from '../../../components/users/users-edit.component';
import { modalLarge, modalSmall, modalMyClass } from '../../modules/dialogOptions';
import { ThrowStmt } from '@angular/compiler';
import { IPagedResults } from '../../../core/interfaces';

@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['../../../components/layout/layout.component.scss']
})
export class UsersListComponent extends BaseComponent implements OnInit {
    dataToDelete: any;
    @Output() userEditView = new EventEmitter();
    @Output() usersModelRolesView = new EventEmitter();
    @Output() DeleteObjectEventData = new EventEmitter();
    @Output() scroll = new EventEmitter<any>();

    @ViewChild('userEdit') userEdit: any;
    public showSpinner: boolean = false;
    public itemPerPage: number = 100;
    public currentPage: number = 1;
    public totalItems: number = 10;
    public accountId: number = 0;
    public model: any;

    searchValue = ""
    userConfirm: string = "";
    //public resending: boolean = false;
    public isAdminOrUserEditor = false;
    public isSuperAdmin = false;
    public isAdmin = false;
    public filterActive: any = "1";
    public filterDept: any = null;
    modalReference: NgbModalRef;
    tosendData: UserModel = new UserModel();
    gridOptions: GridOptions;
    public selectedAdminId: number = 0;
    public overlayLoadingTemplate = '<span class="ag-overlay-loading-center"><i style="font-size: 20px;" class="fa fa-spinner fa-spin"><i></span>';
    private gridApi;
    private gridColumnApi;

    isDownloading = false
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

    }

    public customCellRendererFuncDepartment(params) {

        if (params.data.DepartmentId != 0) {

            var eDiv = document.createElement('div');
            eDiv.innerHTML = params.data.Department.Name;
            return eDiv;
        } else {
            return "";
        }
    };
    public customCellRendererFuncTitle(params) {

        var eDiv = document.createElement('div');
        eDiv.innerHTML = "<span style='text-decoration:underline; cursor: pointer;'>" + params.data.FirstName + "</span>";
        return eDiv;
    };
    columnDefs = [
        {
            headerName: '', width: 40, cellRenderer: this.customCellRendererFuncAction, filter: false
        },
        {
            headerName: 'FirstName', field: 'FirstName',
            resizable: true,
            width: 140,
            sortable: true,
            valueGetter: function(params) {
                return params.data.FirstName;
            },
            //comparator: this.strCompare,
            cellRenderer: this.customCellRendererFuncTitle,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'LastName', field: 'LastName', resizable: true,
            width: 170,
            sortable: true,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'Username', field: 'UserName', resizable: true,
            width: 200,
            sortable: true,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'EmailAddress', field: 'EmailAddress', resizable: true,
            width: 300,
            sortable: true,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'Department', field: 'Department.Name', resizable: true,
            width: 300,
            sortable: true,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'User Role', field: 'RoleName', resizable: true,
            width: 115,
            sortable: true,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'Last Login', field: 'LastLoginDateTime', resizable: true,
            width: 120,
            sortable: true,
            valueFormatter: this.dateFormatterRemindDate, filter: "agDateColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        }

    ];
    dateFormatterRemindDate(params) {

        //var date = params.context.componentParent.getDate();

        var test = moment(params.data.LastLoginDateTime);
        if (test.year() <= 1000) {
            return "";
        }
        return moment(params.data.LastLoginDateTime).format('YYYY-MM-DD HH:mm')

    }
    @ViewChild('resendEmail') resendEmail: TemplateRef<any>;
    @ViewChild('deleteContact') deleteContact: TemplateRef<any>;

    public customCellRendererFuncAction(params) {

        var eDiv = document.createElement('div');
        //<button class="edit">Edit</button></span>1
        // <a><i class='success fa fa-eye edit3'></i></a> &nbsp;
        // <a><i style='color:#ffc107' class='fa fa-pencil edit'></i></a> &nbsp; <a>
        // <a><i style='color:#343a40' class='fa fa-envelope edit2'></i></a>&nbsp; <a><i style='color:red' class='fa fa-trash edit3'></i></a> 
        eDiv.innerHTML = "<span class='my-css-class warning' style='cursor: pointer;'><i class='fa fa-key warning edit1'></i></span>";


        // var eButton = eDiv.querySelectorAll('.edit')[0];
        // eButton.addEventListener('click', function() {            
        //     params.context.componentParent.editUser(params.data.Id,params.rowIndex);
        //     // 

        // });

        var eButton2 = eDiv.querySelectorAll('.edit1')[0];
        eButton2.addEventListener('click', function() {
            params.context.componentParent.editUserRoleModules(params.data.Id, params.rowIndex);//openLg(params.context.componentParent.content,params.data)
        });

        // var eButton3 = eDiv.querySelectorAll('.edit2')[0];
        // eButton3.addEventListener('click', function() {        
        //   params.context.componentParent.openType(params.context.componentParent.resendEmail,params.data);//openLg(params.context.componentParent.content,params.data)
        // });

        // var eButton4 = eDiv.querySelectorAll('.edit3')[0];
        // eButton4.addEventListener('click', function() {        
        //   params.context.componentParent.openDelete(params.context.componentParent.deleteContact,params.data);//openLg(params.context.componentParent.content,params.data)
        // });

        return eDiv;

    };
    departments = []
    rowSelection: string;
    constructor(private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private toastr: ToastsManager,
        private userService: UserService,
        private chRef: ChangeDetectorRef,
        private formBuilder: FormBuilder,
        private departmentService: DepartmentService,
        private modalService: NgbModal) {
        super(router);
        this.rowSelection = "single";
        this._fb = formBuilder;
    }
    onRowClicked(params) {
        if (params.colDef.headerName == "") {

        }
        else {
            params.context.componentParent.editUser(params.data.Id, params.rowIndex);
        }

    }
    packageData: any[];
    packageDataBack: any[];
    dataList: Array<any> = [];
    searchTextControl: FormControl;
    _fb: FormBuilder;

    getIfFiltered(value, compareValue): boolean {
        if (value == null) {
            return false;
        }

        return (value.toLowerCase().includes(compareValue?.toLowerCase()) && (value != null || value != undefined));
    }

    public ngOnInit() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.accountId = currentUser.accountId;

        this.searchTextControl = this._fb.control("");

        this.searchTextControl.valueChanges.pipe(debounceTime(500)).subscribe((data) => {
            this.searchValue = data
            this.filterUserList()
            // if (data == '') {
            //     //this.packageData = this.packageDataBack;
            //     this.filterChange();
            // } else {
            //     this.filterUserList(data)
            // }
        });

        this.gridOptions = <GridOptions>{
            context: {
                componentParent: this
            },
            defaultColDef: {
                filter: true // set filtering on for all cols
            }
        };
        if (this.isSuperAdmin) {

            this.loadData();
        }

        this.departmentService.getDepartmentByAccountId(this.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: IPagedResults<any>) => {
                this.departments = response.Data;
            });
    }

    filterUserList() {
        this.packageData = this.packageDataBack.filter(x => 
            (this.filterActive === '1' && x.IsActive) || 
            (this.filterActive === '2' && !x.IsActive) ||
            this.filterActive === '0')
            .filter(x => (this.getIfFiltered(x.FirstName, this.searchValue) ||
                    this.getIfFiltered(x.LastName, this.searchValue) ||
                    this.getIfFiltered(x.UserName, this.searchValue) ||
                    this.getIfFiltered(x.EmailAddress, this.searchValue) ||
                    this.getIfFiltered(x.Mobile, this.searchValue)) &&
                    (!this.filterDept || this.filterDept == x.DepartmentId));
    }

    public detectChange() {
        this.isAdmin = true;
        this.chRef.detectChanges();
    }
    public loadData(page?: number, id?: number, filter: string = ""): void {
        //  
        this.filterActive = "1";
        this.gridOptions.api.sizeColumnsToFit()
        this.showSpinner = true;
        if (page != null) {
            this.currentPage = page;
        }
        if (id > 0) {
            this.loadDataById(id);
        }
        else {
            this.userService.getUsersList(this.currentPage, this.itemPerPage)
                .catch((err: any) => {
                    return Observable.throw(err);
                })
                .finally(() => {
                    this.showSpinner = false;
                })
                .subscribe((response: any) => {

                    let data = response.Data.filter((item) => {
                        return item.RoleName === 'admin';
                    });
                    this.packageData = data;
                    this.packageDataBack = data;
                    if (filter !== '') {
                        this.dataList = data.filter((item) => {
                            return item.Account.Name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
                        });
                    }
                    this.filterUserList();
                    this.totalItems = response.TotalRecords;
                    //this.toastr.success(response.Message, "Success");
                });
        }
    }

    public loadDataById(id: number) {
        this.accountId = id;
        this.showSpinner = true;
        this.userService.getUsersByAccountList(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: any) => {
                this._fb.control(this.searchValue);
                this.packageData = response.Data.filter(x => x.UserName != 'admin');
                this.packageDataBack = response.Data.filter(x => x.UserName != 'admin');
                this.totalItems = response.Data.length;
                this.filterUserList()
                this.scrollToId();
            });
    }

    scrollToId() {

        setTimeout(() => {

            if (localStorage.getItem('selectedRowUser') != null) {
                // 
                var IdSelected = +localStorage.getItem('selectedRowUser');
                //this.gridOptions.api.ensureIndexVisible(Number(Id))

                this.gridOptions.api.forEachNode((node) => {
                    if (node.data.Id === IdSelected) {
                        // Master open detail.  You could also call node.setSelected( true ); for alternate design.
                        //node.setExpanded(true);
                        this.gridOptions.api.selectNode(node, true);
                        this.gridOptions.api.ensureNodeVisible(node, "middle")
                    }
                });

            }

        }, 500);

    }

    public downloadPDF() {
        this.isDownloading = true
        let currentUser = super.currentLoggedUser();

        this.userService.GetPdf(currentUser.accountId)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                this.isDownloading = false
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response) => {

                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url);

            });
    };

    public editUser(id: number, rowIndex = 0) {

        var selectedRows = this.gridApi.getSelectedRows();
        const modalRef = this.modalService.open(UsersEditComponent, modalLarge);

        localStorage.setItem('selectedRowUser', id.toString());

        modalRef.componentInstance.id = id.toString();
        modalRef.result.then(
            (result) => {
                if (result) {
                    this.searchValue = this.searchTextControl.value
                    this.gridApi.showLoadingOverlay()
                    this.loadData(1, this.accountId);
                }

            },
            (reason) => {
                //this.triggerSearch();
            }
        );
    }

    public editUserRoleModules(id: number, rowIndex = 0) {

        var selectedRows = this.gridApi.getSelectedRows();
        const modalRef = this.modalService.open(UserModuleRoleComponent, modalMyClass);

        //modalRef.componentInstance.userid(id,this.model.AccountId);
        localStorage.setItem('selectedRowUser', id.toString());

        modalRef.componentInstance.userId = id.toString();
        let currentUser = super.currentLoggedUser();
        var tesat = this.accountId;
        modalRef.componentInstance.accountId = currentUser.accountId;// this.model.AccountId.toString();

        modalRef.result.then(
            (result) => {
                if (result) {
                    this.searchValue = this.searchTextControl.value
                    this.gridApi.showLoadingOverlay()
                    this.loadData(1, this.accountId);
                }
            },
            (reason) => {
                //this.triggerSearch();
            }
        );

    }

    public openDelete(title: string, data: any) {
        this.userConfirm = "";
        this.dataToDelete = data;
        console.log(this.dataToDelete);
        this.modalService.open(title, modalSmall);
    }
    public deleteUsers(model: any) {
        this.userService.deleteUser(model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: any) => {

                if (response.Success) {
                    this.toastr.success(response.Message);
                } else {
                    this.toastr.error(response.Message);
                }


                this.DeleteObjectEventData.emit();
            });
    }

    public resendCreateUserConfirmation(model: UserModel) {
        this.tosendData = model;
        model.Resending = true;
        this.userService.resendCreateUserConfirmation(model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: any) => {
                if (response.Success) {
                    this.toastr.success(response.Message, "Create User Confirmation Email Sent.");
                }

                model.Resending = false;
            });

    }

    public openType(content: string, model: UserModel): void {

        this.tosendData = model;
        this.modalReference = this.modalService.open(content, modalSmall);

    }

    public editAccountUser(id: number) {
        if (this.isSuperAdmin) {
            this.router.navigate([`accounts/${id}/edit/users`]);
        }
    }

    public confirmLoginAsUser(content: string, adminId: number) {
        this.modalService.open(content, modalSmall);
        this.selectedAdminId = adminId;
    }

    public loginAsAdminUser() {
        this.superAdminAsAdmin(this.selectedAdminId);
    }

    public superAdminAsAdmin(adminId: number) {
        this.showSpinner = true;
        //make sure to clear the secondary admin data before adding a new one
        localStorage.removeItem('secondaryAdminUser');
        this.userService.getUser(adminId)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {
                this.model = response.Data;
                localStorage.setItem('secondaryAdminUser', JSON.stringify(response.Data));
                const url = `/accounts/${this.model.AccountId}/edit?superAdminAccess=1&accountId=${this.model.AccountId}`
                StorageUtils.setLastUrl(url);
                window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/users-list/users-list.component.ts